import { useEffect, useRef } from 'react';

/**
 * Tasdiqlash oynasi — qaytarib bo'lmaydigan amallar uchun (masalan, chiqish).
 *
 * Native `<dialog>` ishlatiladi: Esc, fokus tuzog'i va fon qorayishi
 * brauzerdan tekinga keladi.
 */

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  body?: string;
  confirmLabel: string;
  cancelLabel: string;
  tone?: 'default' | 'danger';
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  open,
  title,
  body,
  confirmLabel,
  cancelLabel,
  tone = 'default',
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  return (
    <dialog
      ref={ref}
      className="modal"
      aria-labelledby="confirm-title"
      // Esc bosilganda
      onCancel={(e) => {
        e.preventDefault();
        onCancel();
      }}
      // Fon bosilganda
      onClick={(e) => {
        if (e.target === ref.current) onCancel();
      }}
    >
      <div className="modal__body">
        <h2 className="modal__title" id="confirm-title">
          {title}
        </h2>
        {body && <p className="modal__text">{body}</p>}
        <div className="modal__actions">
          <button className="btn" type="button" onClick={onCancel} autoFocus>
            {cancelLabel}
          </button>
          <button
            className={`btn ${tone === 'danger' ? 'btn--danger' : 'btn--primary'}`}
            type="button"
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </dialog>
  );
}
